import {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {MultiMaintenanceScheduleSelect} from "@/components/multiMantenanceScheduleSelect/MultiMaintenanceScheduleSelect.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {ServiceField} from "@/lib/constants/service.ts";

export const LinkScheduleAction = () => {
  const [show, setShow] = useState(false);
  const {getValues, setValue} = useFormContext();

  const defaultValues: number[] = getValues(ServiceField.MAINTENANCE_SCHEDULE_IDS) || [];
  const [scheduleIds, setScheduleIds] = useState<number[]>(defaultValues);

  useEffect(() => {
    setScheduleIds(getValues(ServiceField.MAINTENANCE_SCHEDULE_IDS));
  }, [getValues, defaultValues]);

  return (
    <>
      <Button variant={"secondary"} onClick={() => setShow(true)}>
        <Icon icon={FiPlus} /> Link Schedule
      </Button>
      <ActionDialog
        title={"Link Maintenance Schedules"}
        size="lg"
        hasConfirmButton={true}
        confirmBtnText={"Save Changes"}
        hasCancelButton={true}
        show={show}
        onCancel={function (): void {
          setShow(false);
        }}
        onConfirm={() => {
          setValue(ServiceField.MAINTENANCE_SCHEDULE_IDS, scheduleIds, {shouldDirty: true});
          setShow(false);
        }}
      >
        <MultiMaintenanceScheduleSelect
          tags={[]}
          defaultValue={defaultValues}
          onReplace={(values) => setScheduleIds(values)}
          onAppend={(value) => {
            if (!scheduleIds.includes(value)) {
              setScheduleIds([...scheduleIds, value]);
            }
          }}
        />
      </ActionDialog>
    </>
  );
};
